import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { NavDropdown, Nav, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Shapes } from '../../models/entities';
import FormModal from '../modals/FormModal';
import UserForm from '../forms/UserForm';
import ChangePasswordForm from '../forms/ChangePasswordForm';

class ProfileNav extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTitle: '',
      isEditing: false,
      modalError: undefined,
    };
    this.onHideModal = this.onHideModal.bind(this);
    this.onClickLogout = this.onClickLogout.bind(this);
    this.onViewProfile = this.onViewProfile.bind(this);
    this.onClickChangePassword = this.onClickChangePassword.bind(this);
    this.onSaveNewPassword = this.onSaveNewPassword.bind(this);
  }

  onClickLogout() {
    const { onLogout } = this.props;
    onLogout();
  }

  onViewProfile() {
    this.setState({
      showModal: true,
      modalTitle: 'View Profile',
      isEditing: false,
    });
  }

  onClickChangePassword() {
    this.setState({
      showModal: true,
      modalTitle: 'Change Password',
      isEditing: true,
    });
  }

  onSaveNewPassword({ currentPassword, newPassword }) {
    const { profile, onChangePassword } = this.props;
    onChangePassword(profile.id, currentPassword, newPassword)
      .then(() => {
        toast.success('Password changed successfully!');
        this.onHideModal();
      })
      .catch((error) => this.setState({ modalError: error }));
  }

  onHideModal() {
    this.setState({
      showModal: false,
      modalError: undefined,
      modalTitle: '',
      isEditing: false,
    });
  }

  render() {
    const { profile, clientsById } = this.props;
    const {
      showModal, isEditing, modalTitle, modalError,
    } = this.state;
    let actions;

    if (profile) {
      actions = (
        <Nav>
          <NavDropdown drop="left" title={profile.firstName} id="collapsible-nav-dropdown">
            <NavDropdown.Item onClick={this.onViewProfile}>View Profile</NavDropdown.Item>
            <NavDropdown.Item onClick={this.onClickChangePassword}>
              Change Password
            </NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item onClick={this.onClickLogout}>Logout</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      );
    } else {
      actions = (
        <Nav>
          <Nav.Link>
            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
          </Nav.Link>
        </Nav>
      );
    }

    return (
      <>
        {actions}
        <FormModal
          show={showModal}
          title={modalTitle}
          isEditing={isEditing}
          onHide={this.onHideModal}
          formId="profileForm"
          error={modalError}
        >
          {isEditing ? (
            <ChangePasswordForm
              user={profile}
              formId="profileForm"
              onSubmit={this.onSaveNewPassword}
              onPasswordMismatch={() => this.setState({ modalError: new Error('Passwords does not match') })}
            />
          ) : (
            <UserForm
              user={profile}
              disabled={!isEditing}
              formId="profileForm"
              clientsById={clientsById}
            />
          )}

        </FormModal>
      </>
    );
  }
}

ProfileNav.propTypes = {
  onLogout: PropTypes.func.isRequired,
  onChangePassword: PropTypes.func.isRequired,
  profile: Shapes.USER,
  clientsById: PropTypes.objectOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
};

ProfileNav.defaultProps = {
  profile: null,
  clientsById: {},
};

export default ProfileNav;
